// src/components/admin/AdminLayout.jsx
import React from "react";
import AdminNavbar from "./AdminNavbar";
import AdminSidebar from "./AdminSidebar";
import AdminContent from "./AdminContent";

export default function AdminLayout({
  activeTab,
  setActiveTab,
  sidebarOpen,
  setSidebarOpen,
  handleLogout,
}) {
  return (
    <div className="flex flex-col h-screen bg-gray-50 text-gray-800">

      {/* Navbar */}
      <AdminNavbar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        handleLogout={handleLogout}
      />

      <div className="flex flex-1 overflow-hidden">

        {/* Sidebar desktop */}
        <div className="hidden md:flex flex-shrink-0">
          <AdminSidebar
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>

        {/* Mobile overlay sidebar */}
        {sidebarOpen && (
          <div className="md:hidden fixed inset-0 z-40 flex">
            {/* Backdrop */}
            <div
              className="absolute inset-0 bg-black/40"
              onClick={() => setSidebarOpen(false)}
            />
            {/* Sidebar container */}
            <div className="relative bg-white shadow-xl overflow-auto">
              <AdminSidebar
                activeTab={activeTab}
                setActiveTab={(tab) => {
                  setActiveTab(tab);
                  setSidebarOpen(false);
                }}
              />
            </div>
          </div>
        )}

        {/* Main content */}
        <main className="flex-1 flex flex-col overflow-hidden">
          <div className="flex-1 overflow-y-auto">
            <AdminContent activeTab={activeTab} />
          </div>
        </main>

      </div>
    </div>
  );
}
